// import { IoCodeSlash } from "react-icons/io5";
// import guyWithLaptiop from "../Images/guy_with_laptop.png";
// import penSvg from "../Images/pen.svg";
// import discover from "../Images/discover.svg";
// import share from "../Images/share.svg";
// import verify from "../Images/verify.svg";
// import { FiDatabase } from "react-icons/fi";
// import cyberExperience from "../Images/cyberpack_experience.png";
// import cbp01 from "../Images/development-frameworks.svg";
// import cbp02 from "../Images/it-professionals.svg";
// import cbp03 from "../Images/projects-completed.svg";
// import { MarqueeComponent } from "../Components/MarqueeComponent";
import teamMember1 from "../Images/Staffs/Co-Founder_CEO.jpg";
import teamMember2 from "../Images/Staffs/Richard-Creative-director.jpg";
import teamMember3 from "../Images/Staffs/Gideon_Olumide_PM.jpg";
import teamMember4 from "../Images/Staffs/Tokmang.jpg";
import teamMember5 from "../Images/Staffs/Raphael.png";
// import { OurProject } from "../Components/OurProject";
// import testLeft from "../Images/testimonial.png";
// import { useNavigate } from "react-router-dom";
// import * as routes from "../Data/Routes";
// import Typewriter from "../Components/Typewritter";
// import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
// import wavezio from "../Images/wavezio.png";
// import productDesign from "../Images/productDesign.png";
import { useEffect } from "react";
import { ProjectEnquiry } from "./ProjectEnquiry";
// import { BiSolidRightArrow } from "react-icons/bi";
// import ProcessFlow from "./ProcessFlow";

export const MeetTheTeam = () => {
  // const navigate = useNavigate();

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: smooth scrolling animation
      });
    };
    handleScrollToTop();
  }, []);

  return (
    <div className="flex flex-col pt-[60px]">
      <div id="home" className="bg-[#1B1B22]">
        <div className="h-fit lg:min-h-[50vh] flex flex-col items-center justify-center mb-5">
          <div className="mt-5 lg:mt-0">
            <div className="text-[30px] md:text-[45px] lg:text-[50px] xl:text-[55px] text-[#0FB8F9]  font-semibold leading-[100%] mt-8 mb-2 text-center">
              Meet the team
            </div>

            <div className="text-[#FAFAFA] text-base md:text-2xl leading-[150%] tracking-[0%] my-10 font-normal text-center mx-auto lg:mx-0 w-[90vw] md:w-[80vw] lg:w-[65vw]">
              The minds behind the code, the strategy behind the design.
            </div>

            <div className="leading-[170%] tracking-[0%] text-sm md:text-base lg:text-[25px] text-center text-white w-[90vw] md:w-[80vw] lg:w-[65vw] mx-auto">
              We’re a global team of designers, developers, and product thinkers
              united by a shared passion for building meaningful digital
              experiences. We don’t just execute; we collaborate, challenge
              ideas, and bring bold thinking to every product we create.
            </div>
          </div>
        </div>
      </div>

      <section id="our-people" className="bg-[#1B1B22]">
        <div className="lg:h-fit w-fit px-[5vw] xl:px-[5vw] flex flex-col items-center justify-center mx-auto">
          <div className="mr-auto">
            <div className="h-fit flex items-center mt-20">
              <hr className="rotate-180 bg-[#09A7E4] h-[42px] w-[6px] rounded-[50px]" />{" "}
              <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
                <span className="font-medium">OUR</span>
                <br />
                <span className="font-bold">People</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 py-10">
            {[
              {
                firstname: "Olakunle",
                lastname: "IGBAROOLA",
                position: "Co-founder / CEO",
                image: teamMember1,
              },
              {
                firstname: "Tokmang",
                lastname: "Wang",
                position: "Head of operation",
                image: teamMember4,
              },
              {
                firstname: "Richard",
                lastname: "OBARO",
                position: "Creative director",
                image: teamMember2,
              },
              {
                firstname: "Olumide",
                lastname: "GIDEON",
                position: "Project manager",
                image: teamMember3,
              },
              {
                firstname: "Raphael",
                lastname: "OLAIYAPO",
                position: "Lead developer",
                image: teamMember5,
              },
            ].map((member, index) => (
              <div key={index} className="bg-[#2A2A2F] rounded-br-[50px]">
                <div className="w-[70vw] md:w-[251px] h-[277px] rounded-br-[50px] border-b-[3px] border-b-[#09A7E4] overflow-hidden">
                  <img
                    src={member.image}
                    alt="Team Member 1"
                    className="w-full h-full"
                  />
                </div>
                <div className="leading-[130%] tracking-[0%] font-normal text-xl text-[#09A7E4] pl-2 mt-5">
                  {member.firstname}
                </div>
                <div className="leading-[130%] tracking-[0%] font-normal text-xl text-[#F0FBFF] pl-2">
                  {member.lastname}
                </div>
                <hr className="border-[#565658] my-5 w-[90%] mx-auto" />
                <div className="leading-[130%] tracking-[0%] font-normal text-xl text-[#F0FBFF] my-5 pl-2">
                  {member.position}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div
        id="team-values"
        className="lg:h-[664px] bg-[#1B1B22] px-[5vw] py-10 lg:py-0 flex flex-col lg:flex-row items-center justify-center"
      >
        <div className="py-4 flex items-center justify-center lg:mt-20 mr-auto lg:mr-0">
          <hr className="rotate-180 bg-[#09A7E4] h-[42px] w-[6px] rounded-[50px]" />{" "}
          <div className="text-[#09A7E4] ml-3 py-2">
            <div className="font-medium leading-[100%] tracking-[0%] text-xl">
              OUR
            </div>
            <div className="font-bold leading-[100%] tracking-[0%] text-[35px] mt-2">
              Team Values
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:ml-16 xl:ml-20">
          <div className="w-[344px] h-[198px] rounded-[30px] p-[25px] bg-[#2A2A2F] flex flex-col items-start justify-center">
            <div className="text-[25px] font-semibold leading-[100%] tracking-[0%] text-[#F0FBFF]">
              Collaboration over silos
            </div>
            <hr className="border-[#3D3D41] w-full my-5" />
            <div className="text-[20px] leading-[130%] tracking-[0%] text-[#F0FBFF]">
              We work together across time zones, roles, and tools to deliver
              our best work.
            </div>
          </div>

          <div className="w-[344px] h-[198px] rounded-[30px] p-[25px] bg-[#2A2A2F] flex flex-col items-start justify-center">
            <div className="text-[25px] font-semibold leading-[100%] tracking-[0%] text-[#F0FBFF]">
              User-first thinking
            </div>
            <hr className="border-[#3D3D41] w-full my-5" />
            <div className="text-[20px] leading-[130%] tracking-[0%] text-[#F0FBFF]">
              Every decision is guided by empathy and real user needs.
            </div>
          </div>

          <div className="w-[344px] h-[198px] rounded-[30px] p-[25px] bg-[#2A2A2F] flex flex-col items-start justify-center">
            <div className="text-[25px] font-semibold leading-[100%] tracking-[0%] text-[#F0FBFF]">
              Craft meets code
            </div>
            <hr className="border-[#3D3D41] w-full my-5" />
            <div className="text-[20px] leading-[130%] tracking-[0%] text-[#F0FBFF]">
              We blend creative design with engineering precision.
            </div>
          </div>

          <div className="w-[344px] h-[198px] rounded-[30px] p-[25px] bg-[#2A2A2F] flex flex-col items-start justify-center">
            <div className="text-[25px] font-semibold leading-[100%] tracking-[0%] text-[#F0FBFF]">
              Always learning
            </div>
            <hr className="border-[#3D3D41] w-full my-5" />
            <div className="text-[20px] leading-[130%] tracking-[0%] text-[#F0FBFF]">
              We stay ahead by staying curious, humble, and open to new ideas.
            </div>
          </div>
        </div>
      </div>

      <ProjectEnquiry />
    </div>
  );
};
